import { WallPost } from '../../../api/wallPostsApi';
import { getMediaUrl } from '../../../utils/avatarUtils';

/** Объект в фильтре профиля (извлекается из постов) */
export interface PostSite {
  id: number;
  name: string;
  coverImage: string | null;
}

/**
 * Извлекает уникальные объекты (сайты) из постов для фильтра по объекту.
 * Берёт обложку из последнего поста по дате для каждого объекта.
 */
export function getSitesFromPosts(posts: WallPost[]): PostSite[] {
  const siteMap = new Map<number, PostSite>();

  const sortedPosts = [...posts].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  for (const post of sortedPosts) {
    if (!post.siteId || !post.siteName) continue;

    if (!siteMap.has(post.siteId)) {
      const lastImage =
        post.images && post.images.length > 0 ? post.images[post.images.length - 1] : null;
      siteMap.set(post.siteId, {
        id: post.siteId,
        name: post.siteName,
        coverImage: lastImage
          ? getMediaUrl(lastImage, 'avatar') || getMediaUrl(lastImage, 'full')
          : null,
      });
    } else {
      const existing = siteMap.get(post.siteId)!;
      if (existing.coverImage) continue;
      const lastImage =
        post.images && post.images.length > 0 ? post.images[post.images.length - 1] : null;
      if (lastImage) {
        siteMap.set(post.siteId, {
          ...existing,
          coverImage: getMediaUrl(lastImage, 'avatar') || getMediaUrl(lastImage, 'full'),
        });
      }
    }
  }

  return Array.from(siteMap.values()).sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * Добавляет объекты из новых постов к существующему списку (по id).
 * Не удаляет объекты при фильтрации — список объектов для фильтра всегда полный.
 */
export function mergeSitesFromPosts(existing: PostSite[], newPosts: WallPost[]): PostSite[] {
  const fromNew = getSitesFromPosts(newPosts);
  const byId = new Map(existing.map((s) => [s.id, s]));
  for (const s of fromNew) {
    const cur = byId.get(s.id);
    if (!cur) {
      byId.set(s.id, s);
    } else if (!cur.coverImage && s.coverImage) {
      byId.set(s.id, { ...cur, coverImage: s.coverImage });
    }
  }
  return Array.from(byId.values()).sort((a, b) => a.name.localeCompare(b.name));
}
